import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';
import { UpdateSalesIdService } from 'src/app/services/update-salesid.service';

@Component({
  selector: 'app-virtual-calling',
  templateUrl: './virtual-calling.component.html',
  styleUrls: ['./virtual-calling.component.css']
})
export class VirtualCallingComponent implements OnInit {
  changescidForm: UntypedFormGroup;
  formErrors = {

    'salesChannelCode': ''


  };
  ValidationMessages = {

    'accId': {
      'required': 'Phone number is Required',
      'pattern': 'Only numbers are allowed'
    },
    'salesChannelCode': {
      'required': 'Phone number is Required',
      'pattern': 'Only numbers are allowed'
    }
  };
  accountId: any;
  accId: any;
  salesChannelCode: any;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;

  constructor(private formbuilder: UntypedFormBuilder,
    private UpdateSalesIdService: UpdateSalesIdService,
        private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.changescidForm = this.formbuilder.group({

      salesChannelCode: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      // accId: this.data

    });
    console.log(this.data);
    this.accId = this.data;
  }

  ngOnInit() {
  }
  // logValidationErrors(group: FormGroup = this.changePhoneForm): void {
  //   Object.keys(group.controls).forEach((key: string) => {
  //     const abstractControl = group.get(key);
  //     this.formErrors[key] = '';
  //     if (abstractControl && !abstractControl.valid &&
  //       (abstractControl.touched || abstractControl.dirty)) {
  //       const messages = this.ValidationMessages[key];
  //       for (const errorKey in abstractControl.errors) {
  //         if (errorKey) {
  //           this.formErrors[key] += messages[errorKey] + ' ';
  //         }
  //       }
  //     }

  //     if (abstractControl instanceof FormGroup) {
  //       this.logValidationErrors(abstractControl);
  //     }
  //   });


  // }
  onUpdateIdConfirm() {
    this.api_error = '';
    this.api_success = '';
    // this.logValidationErrors();
    console.log(this.changescidForm.get('salesChannelCode').value);
    this.UpdateSalesIdService.updateSalesid(this.accId , this.changescidForm.get('salesChannelCode').value)
        .subscribe(res => {
          this.api_success = 'updated successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
           }
        );
  }
}
